import styled from 'styled-components'

export const Header = styled.div`
  position: sticky;
  top: 0;
  z-index: 1;
  height: 64px;
  background-color: #2d323e;
  padding: 0 16px;
  font-size: 24px;
  display: flex;
  align-items: center;
  color: #fff;
  box-shadow: rgba(99, 99, 99, 0.2) 0 2px 8px 0;

  > * {
    cursor: default;
  }
`

export const Container = styled.div`
  padding: 20px;
  overflow: auto;
  height: calc(100dvh - 64px);
`

export const Logo = styled.img.attrs({
  src: '/images/logo-mini.png',
  width: 32,
  height: 26
})``

export const LogoContainer = styled.div`
  display: flex;
  padding: 0 8px;
  min-height: 56px;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  height: 64px;
  margin-left: -16px;
  width: 72px;
  margin-right: 24px;
`

export const ButtonsWrapper = styled.div`
  margin-left: auto;
  display: flex;
  gap: 16px;
`
